export default __webpack_public_path__ + "assets/delete-section.bc9d1a20.png";